import React, { useState } from 'react';
import { getImageUrl } from '../../../../config';
import Button from '../../../common/buttons/button/Button';
import {
	ACCOUNT_INVOICES_TITLE,
	ACCOUNT_INVOICES_NEXT_BILLING_DATE,
	ACCOUNT_INVOICES_HISTORY,
	ACCOUNT_INVOICES_ONLY_LATEST_DISPLAYED,
	ACCOUNT_INVOICES_EMPTY,
	REFRESH,
	SHOW_MORE,
	SHOW_LESS,
} from '../../../../constants/Copy';
import { stateRender } from '../../../../helpers/react';
import './Invoices.scss';
import InvoiceListItem from './InvoiceListItem';
import { useSelector } from 'react-redux';
import { friendlyDate } from '../../../../helpers/datetime';
import { isOnFreeTier } from '../../../../helpers/tiers';
import { initiateTrackStructEvent } from '../../../analytics/Snowplow';
import {
	EVT_ELEMENT_INTERACTION,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_INVOICE,
	EVT_ACCOUNT,
	EVT_INVOICE_SHOW_MORE,
	EVT_INVOICE_SHOW,
} from '../../../../constants/SnowplowEvents';

const CLOSED_MAX_INVOICES = 5;

const InvoicesList = ({ isCancelled, origin, invoices, isLoading, error, refetch }) => {
	const [isOpen, setIsOpen] = useState(false);
	const activeSubscription = useSelector((state) => state.subscription.details.data);
	const { nextBillingDate, currentPlan } =
		useSelector((state) => state.subscription.tier.data) || {};

	if (!activeSubscription) return null;

	const isTermedSubscription = activeSubscription.termType === 'TERMED';

	function toggleOpen() {
		setIsOpen(!isOpen);
	}

	return (
		<div className="account__component-invoices">
			<h2>{ACCOUNT_INVOICES_TITLE}</h2>
			{!isOnFreeTier(currentPlan?.planDescription.tierId) &&
			!isTermedSubscription &&
			nextBillingDate &&
			!isCancelled ? (
				<p className="next-billing-bedrock">
					{ACCOUNT_INVOICES_NEXT_BILLING_DATE}: <span>{friendlyDate(nextBillingDate)}</span>
				</p>
			) : null}
			<p className="invoices-list-header">{ACCOUNT_INVOICES_HISTORY}</p>
			{stateRender({
				isPending: isLoading,
				isError: error,
				onSuccess: () => invoices && renderInvoices(),
			})}
		</div>
	);

	function renderInvoices() {
		const buttonText = !isOpen ? SHOW_MORE : SHOW_LESS;
		let newInvoices = invoices ? [...invoices] : [];
		if (!newInvoices?.length) {
			return <EmptyInvoices />;
		}
		newInvoices = [...Object.values(invoices)];
		newInvoices
			.sort((a, b) => b.invoiceDate - a.invoiceDate)
			.sort(function (a, b) {
				if (a.outstandingBalance !== 0 && a.openPayments?.length > 0) return -1;
				if (b.outstandingBalance !== 0 && b.openPayments?.length > 0) return 1;
				return 0;
			});

		return (
			<>
				<ul>
					{(isOpen ? newInvoices : newInvoices.slice(0, CLOSED_MAX_INVOICES)).map(
						(invoice, index) => (
							<InvoiceListItem
								invoice={invoice}
								key={invoice.id}
								index={index}
								showPDFButton
								origin={origin}
							/>
						)
					)}
				</ul>
				<p className="invoice-list-text">{ACCOUNT_INVOICES_ONLY_LATEST_DISPLAYED}</p>
				{newInvoices.length > CLOSED_MAX_INVOICES && (
					<div className="invoices__open">
						<Button
							onClick={() => {
								initiateTrackStructEvent({
									category: EVT_ACCOUNT,
									action: EVT_INVOICE_SHOW_MORE,

									rtlElementContext: {
										elementInteraction: EVT_ELEMENT_INTERACTION,
										elementGroup: EVT_INVOICE,
										elementType: EVT_ELEMENT_TYPE_BUTTON,
										elementName: EVT_INVOICE_SHOW,
										elementLabel: buttonText,
									},
								});
								toggleOpen();
							}}
						>
							{buttonText}
						</Button>
					</div>
				)}
			</>
		);
	}

	function EmptyInvoices() {
		const emptyInvoicesIcon = getImageUrl('/images/v2-empty-invoices.svg');
		return (
			<>
				<div className="invoices--empty" role="empty-invoices">
					<img
						src={emptyInvoicesIcon}
						className="invoices--empty__icon"
						alt={ACCOUNT_INVOICES_EMPTY}
					/>
					<p className="invoices--empty__text">{ACCOUNT_INVOICES_EMPTY}</p>
				</div>
				<div className="invoices--empty-button">
					<Button onClick={() => refetch()}>{REFRESH}</Button>
				</div>
			</>
		);
	}
};

export default InvoicesList;
